type ProposalDateFields = {
  dateEnd?: string | Date | null
}

/** Data de encerramento já passou (após o fim do dia de dateEnd). */
export function isProposalDeadlineExceeded(
  proposal: ProposalDateFields | null | undefined
): boolean {
  if (!proposal?.dateEnd) {
    return false
  }

  const end = new Date(proposal.dateEnd)
  end.setHours(23, 59, 59, 999)

  return new Date() > end
}
